module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing_1_LV-22c4ee8ee4a7d91dfddee3165c9709de.svg";